webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(226);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(176);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(401);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _index = __webpack_require__(223);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _router = __webpack_require__(218);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _vuex = __webpack_require__(177);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _store = __webpack_require__(111);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vant = __webpack_require__(349);
	
	var _vant2 = _interopRequireDefault(_vant);
	
	__webpack_require__(291);
	
	var _elementUi = __webpack_require__(274);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(290);
	
	var _axios = __webpack_require__(200);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(301);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_elementUi2.default);
	_vue2.default.use(_vant2.default);
	__webpack_require__(138).polyfill();
	_vue2.default.use(_vuex2.default);
	_App2.default.store = _store2.default;
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.directive('transfer-dom', _index2.default);
	
	_vue2.default.prototype.$http = _axios2.default;
	
	_axios2.default.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
	
	_axios2.default.interceptors.request.use(function (config) {
	
	  if (config.method === 'post') {
	    config.data = _qs2.default.stringify(config.data);
	  }
	  config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
	  if (window.localStorage.getItem('auth') && window.localStorage.getItem('auth') !== '') {
	    config.headers.token = '' + window.localStorage.getItem('auth');
	  }
	  return config;
	}, function (err) {
	  return _promise2.default.reject(err);
	});
	
	new _vue2.default({
	  el: '#root',
	  router: _router2.default,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    remoteDingtalkUrl: 'https://www.hzmetro.online:8443/dingtalk_server',
	    javaUrl: 'https://hzmetro-b-app.mtros.cn:9003/disinfection/',
	    agentId: '1083910581',
	    corpid: 'dingf18a38c956b37f53' };

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_USER_ID = exports.SET_USER_ID = 'SET_USER_ID';
	var SET_USER_NAME = exports.SET_USER_NAME = 'SET_USER_NAME';
	var SET_COMPLETE_ANS = exports.SET_COMPLETE_ANS = 'SET_COMPLETE_ANS';
	var SET_TASK_ID = exports.SET_TASK_ID = 'SET_TASK_ID';
	var SET_BASE_INFO = exports.SET_BASE_INFO = 'SET_BASE_INFO';
	var SET_PROCESS_ID = exports.SET_PROCESS_ID = 'SET_PROCESS_ID';
	var SET_NEXT_PROCESS_ID = exports.SET_NEXT_PROCESS_ID = 'SET_NEXT_PROCESS_ID';
	var SET_NODE_INFO = exports.SET_NODE_INFO = 'SET_NODE_INFO';
	var SET_CHECKED_USER = exports.SET_CHECKED_USER = 'SET_CHECKED_USER';
	var SET_USER_LIST = exports.SET_USER_LIST = 'SET_USER_LIST';
	var SET_COUNT = exports.SET_COUNT = 'SET_COUNT';

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(177);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _user = __webpack_require__(220);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _logger = __webpack_require__(400);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var debug = ("production") !== 'production';
	
	exports.default = new _vuex2.default.Store({
	    modules: {
	        user: _user2.default
	    },
	    strict: debug,
	    moddlewares: debug ? [(0, _logger2.default)()] : []
	});
	module.exports = exports['default'];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(176);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	var router = new _vueRouter2.default({
	    routes: [{
	        path: '/:id',
	        name: 'home',
	        component: __webpack_require__(402),
	        auth: true
	    }],
	    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	        return { x: 0, y: 0 };
	    }
	});
	exports.default = router;
	module.exports = exports['default'];

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setCount = exports.setCheckedUser = exports.setUserList = exports.setNodeInfo = exports.setNextProcessId = exports.setProcessId = exports.setBaseInfo = exports.setCompleteAns = exports.setTaskId = exports.setUserName = exports.setUserId = undefined;
	
	var _mutationTypes = __webpack_require__(110);
	
	__webpack_require__(138).polyfill();
	__webpack_require__(295);
	
	var setUserId = exports.setUserId = makeAction(_mutationTypes.SET_USER_ID);
	var setUserName = exports.setUserName = makeAction(_mutationTypes.SET_USER_NAME);
	var setTaskId = exports.setTaskId = makeAction(_mutationTypes.SET_TASK_ID);
	var setCompleteAns = exports.setCompleteAns = makeAction(_mutationTypes.SET_COMPLETE_ANS);
	var setBaseInfo = exports.setBaseInfo = makeAction(_mutationTypes.SET_BASE_INFO);
	var setProcessId = exports.setProcessId = makeAction(_mutationTypes.SET_PROCESS_ID);
	var setNextProcessId = exports.setNextProcessId = makeAction(_mutationTypes.SET_NEXT_PROCESS_ID);
	var setNodeInfo = exports.setNodeInfo = makeAction(_mutationTypes.SET_NODE_INFO);
	var setUserList = exports.setUserList = makeAction(_mutationTypes.SET_USER_LIST);
	var setCheckedUser = exports.setCheckedUser = makeAction(_mutationTypes.SET_CHECKED_USER);
	var setCount = exports.setCount = makeAction(_mutationTypes.SET_COUNT);
	function makeAction(type) {
	    return function (_ref) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            args[_key - 1] = arguments[_key];
	        }
	
	        var dispatch = _ref.dispatch;
	        return dispatch.apply(undefined, [type].concat(args));
	    };
	}

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(229);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	    userId: '',
	    userName: '',
	    taskId: '',
	    processId: '',
	    nextProcessId: '',
	    completeAns: false,
	    baseInfo: '',
	    nodeInfo: '',
	    checkedUser: [],
	    userList: [],
	    count: 0
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_USER_ID, function (state, newUserId) {
	    state.userId = newUserId;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_USER_NAME, function (state, newUserName) {
	    state.userName = newUserName;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_TASK_ID, function (state, newTaskId) {
	    state.taskId = newTaskId;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_COMPLETE_ANS, function (state, nowStatus) {
	    state.completeAns = nowStatus;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_BASE_INFO, function (state, nowBaseInfo) {
	    state.baseInfo = nowBaseInfo;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_PROCESS_ID, function (state, nowProcessId) {
	    state.processId = nowProcessId;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_NEXT_PROCESS_ID, function (state, nowNextProcessId) {
	    state.nextProcessId = nowNextProcessId;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_NODE_INFO, function (state, nowNodeInfo) {
	    state.nodeInfo = nowNodeInfo;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_USER_LIST, function (state, nowUserList) {
	    state.userList = nowUserList;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_CHECKED_USER, function (state, nowCheckedUser) {
	    state.checkedUser = nowCheckedUser;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_COUNT, function (state, nowCount) {
	    state.count = nowCount;
	}), _mutations);
	
	exports.default = {
	    state: state,
	    mutations: mutations
	};
	module.exports = exports['default'];

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _env = __webpack_require__(109);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _actions = __webpack_require__(219);
	
	var _store = __webpack_require__(111);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    store: _store2.default,
	    mounted: function mounted() {
	        this.$nextTick(function () {});
	    },
	    provide: function provide() {
	        return {};
	    },
	    data: function data() {
	        return {
	            isRouterAlive: true,
	            signture: {},
	            loading: 0
	        };
	    },
	
	    components: {},
	    methods: {
	        getUserInfo: function getUserInfo() {
	            var that = this;
	            this.$http({ url: _env2.default.remoteDingtalkUrl + '/v1/user/' + that.userId, method: 'GET' }).then(function (response) {
	                if (response.data.status === 'ok') {
	                    console.log('获取员工信息成功，写入vuex');
	                    that.setUserName(response.data.user.name);
	                    that.$router.push('/home');
	                } else {
	                    window.alert('获取员工信息异常，可能部分功能异常！');
	                }
	            }, function (response) {
	                window.alert('服务器好像走神了，请稍后再试吧！');
	                console.log('err in get ques');
	            });
	        }
	    },
	    vuex: {
	        actions: {
	            setUserId: _actions.setUserId,
	            setUserName: _actions.setUserName
	        },
	        getters: {
	            employeeNumber: function employeeNumber(state) {
	                return state.user.employeeNumber;
	            },
	            userId: function userId(state) {
	                return state.user.userId;
	            }
	        }
	    }
	};
	module.exports = exports['default'];

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(67);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _env = __webpack_require__(109);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    created: function created() {
	        this.getBaseInfo();
	        this.initTimer();
	    },
	
	    mounted: function mounted() {
	        this.height = window.innerHeight + 34 + 'px';
	        this.$nextTick(function () {
	            this.height = window.innerHeight + 34 + 'px';
	        });
	    },
	    data: function data() {
	        return {
	            flag: true,
	            height: '',
	            result: {
	                disinfectionMethod: '',
	                createdAt: '',
	                positionName: ''
	            },
	            monthDate: '',
	            hoursMinute: ''
	        };
	    },
	
	    methods: {
	        initTimer: function initTimer() {
	            this.getTime();
	            setInterval(this.initTimer, 1000);
	            this.clear();
	        },
	        clear: function clear() {
	            clearInterval(this.initTimer);
	            this.initTimer = null;
	        },
	        getBaseInfo: function getBaseInfo() {
	            var that = this;
	            var data = {};
	            data.positionCode = this.$route.params.id;
	            this.$http({ url: _env2.default.javaUrl + 'disinfection/query-disinfection-record', data: data, method: 'POST' }).then(function (response) {
	                if (response.data.status === 'ok') {
	                    if (response.data.content.record && response.data.content.record.id) {
	                        that.result = (0, _extends3.default)({}, response.data.content.record);
	                    } else {
	                        that.flag = false;
	                    }
	                } else if (response.data.status === 'err') {
	                    that.$dialog.alert({
	                        title: '提示',
	                        message: response.data.message
	                    }).then(function () {});
	                }
	            }, function (response) {
	                that.$dialog.alert({
	                    title: '提示',
	                    message: 'disinfection/query-disinfection-record接口异常'
	                }).then(function () {});
	            });
	        },
	        getTime: function getTime() {
	            var date = new Date();
	            var month = date.getMonth() + 1;
	            var day = date.getDate();
	            var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
	            var minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
	            var second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
	            this.monthDate = month + '月' + day + '日';
	            this.hoursMinute = hours + ':' + minute + ':' + second;
	        }
	    }
	};
	module.exports = exports['default'];

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/404.9ed13bb.svg";

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/hang.2ad4962.png";

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/main.97ec471.png";

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/top.1062b7f.png";

/***/ }),

/***/ 398:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.flag) ? _c('div', {
	    staticClass: "main-top",
	    style: ({
	      height: _vm.height
	    }),
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "text-align": "left"
	    }
	  }, [_c('el-card', {
	    attrs: {
	      "shadow": "always"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "calc(100%)",
	      "text-align": "center"
	    }
	  }, [_c('img', {
	    staticClass: "pimg",
	    attrs: {
	      "src": __webpack_require__(311),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticStyle: {
	      "padding": "0",
	      "padding-top": "20px",
	      "margin": "0",
	      "font-size": "34px"
	    }
	  }, [_vm._v(_vm._s(_vm.monthDate)), _c('br'), _vm._v(_vm._s(_vm.hoursMinute))]), _vm._v(" "), _c('van-divider'), _vm._v(" "), _c('img', {
	    attrs: {
	      "width": "140px",
	      "src": __webpack_require__(310)
	    }
	  }), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "padding": "0",
	      "margin": "0",
	      "font-size": "17px",
	      "font-weight": "700",
	      "color": "green",
	      "line-height": "30px",
	      "margin-top": "5px"
	    }
	  }, [_vm._v("\n                        " + _vm._s(_vm.result.positionName))]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "text-align": "left",
	      "margin-top": "20px"
	    }
	  }, [(_vm.result.positionName !== '') ? _c('p', {
	    staticStyle: {
	      "padding": "0",
	      "margin": "0",
	      "font-size": "15px",
	      "line-height": "25px",
	      "margin-top": "5px"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-weight": "700"
	    }
	  }, [_vm._v("绿码：")]), _vm._v("该区域已按时消杀")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "special",
	    staticStyle: {
	      "padding-top": "10px"
	    }
	  }, [_c('van-divider'), _vm._v(" "), _c('div', {
	    staticClass: "noBa"
	  }, [_c('van-icon', {
	    attrs: {
	      "name": "passed"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-left": "5px"
	    },
	    attrs: {
	      "role": "marquee"
	    }
	  }, [_vm._v("\n                                已消杀\n                            ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "footed"
	  }, [_vm._v("\n                            最新消杀时间\n                        ")]), _vm._v(" "), _c('div', {
	    staticClass: "footedl"
	  }, [_vm._v("\n                            " + _vm._s(_vm.result.createdAt) + "\n                        ")]), _vm._v(" "), _c('div', {
	    staticClass: "fimg"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(309),
	      "width": "85px",
	      "alt": ""
	    }
	  })])], 1)], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('br')]) : _c('div', {
	    staticClass: "p404"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "calc(100% - 100px)"
	    },
	    attrs: {
	      "src": __webpack_require__(308)
	    }
	  }), _vm._v(" "), _vm._m(0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "padding": "10px"
	    }
	  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('div', {
	    staticClass: "desc",
	    attrs: {
	      "data-v-206e07da": ""
	    }
	  }, [_vm._v("抱歉，功能还未开放，敬请期待。")])])
	}]}

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(292)
	
	/* script */
	__vue_exports__ = __webpack_require__(221)
	
	/* template */
	var __vue_template__ = __webpack_require__(398)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(293)
	
	/* script */
	__vue_exports__ = __webpack_require__(222)
	
	/* template */
	var __vue_template__ = __webpack_require__(399)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 405:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.4df547ec79dbf441ae81.1615801888628.js